export const name = 'personalInvoices-api-config'
const prefix = '/api/v2/agent'
export const api = {
  personalInvoices: {
    cardList: `${prefix}/purchaser/mobile/ticket/page`, // post
    deleteCard: `${prefix}/purchaser/we-chat/ticket/mobileDeleteInvoice`, // post
    getCard: `${prefix}/purchaser/invoice/info`, // get
    getStrangeCard: `${prefix}/exceptionInvoice/info/`, // post
    getNonVat: `${prefix}/purchaser/we-chat/non-vat/:id`,
    getInvoiceInfo: `${prefix}/purchaser/invoice/getByInvoiceCodeAndNo`, // GET 正常发票查询详情
    getAbnormalInvoiceInfo: `${prefix}/exceptionInvoice/getByInvoiceCodeAndNo`, // GET 异常发票查询详情
    getNonInvoiceInfo: `${prefix}/purchaser/we-chat/non-vat/getByInvoiceNo` // GET 非增发票查询详情
  }
}
